import _ from 'underscore'
import React from 'react'
import styled from 'styled-components'
import { Moment, tz } from 'moment-timezone'

import { sortBasedOnSeverity } from 'helpers/alerts'
import { shortDateWithDayOfWeek } from 'helpers/formatters'

import CollapsiblePanel from 'components/CollapsiblePanel'
import HomeownerDayNotification from 'pages/shared/HomeownerAlert/HomeownerDayNotification'

import AlertList from 'pages/shared/AlertList'
import AlertIconWithCount from 'pages/shared/Alert/IconWithCount'

import { Alert } from 'types/Alert'
import { color } from 'styles/colors'

type Props = {
  occurredDay: number
  timeZone: string
  alerts: Array<Alert>
  showDayRthCallback: (day: Moment) => void
}

const AlertsDayHistory = ({ occurredDay, timeZone, alerts, showDayRthCallback }: Props) => {
  sortBasedOnSeverity(alerts)

  const countAlertTypes = _.chain(sortBasedOnSeverity(alerts)).groupBy(alert => alert.severity).value()

  return (
    <S.CollapsiblePanel key={occurredDay}
      headerComponent={
        <S.Header>
          <span>
            {shortDateWithDayOfWeek(tz(occurredDay, timeZone))}
          </span>
          <S.AlertTypes>
            {_.map(Object.entries(countAlertTypes), ([key, value]) => <AlertIconWithCount key={key} severity={key} count={value.length} />)}
          </S.AlertTypes>
          <S.HomeownerLastNotified date={new Date(occurredDay)} />
        </S.Header>
      }
    >
      <S.AlertList alerts={alerts.slice(0, 20)} headerType="AlertHistory" showDayRthCallback={showDayRthCallback} />
      {alerts.length > 20 && <S.Note>Over 20 alerts were triggered on this day, see Runtime History for more details.</S.Note>}
    </S.CollapsiblePanel>
  )
}

export default AlertsDayHistory

const S = {
  CollapsiblePanel: styled(CollapsiblePanel)`
    padding: 1px 0px;
  `,
  Header: styled.div`
    display: flex;
    padding: 10px 0px;
    align-items: center;
  `,
  AlertTypes: styled.div`
    display: flex;
    align-items: normal;
    margin-left: 10px;
  `,
  AlertList: styled(AlertList)`
    border-bottom: 1px solid ${color('divider')};

    & > div {
      padding-left: 15px;
    }
  `,
  Note: styled.div`
    text-align: center;
    font-style: italic;
    margin: 10px;
    color: ${color('ancillaryText')};
  `,
  HomeownerLastNotified: styled(HomeownerDayNotification)`
    margin: 0 15px 0 auto;
  `
}
